export default class ArgumentNullError extends Error {
    constructor(paramName: string) {
        super(`Parameter '${paramName}' is required.`);

        this.name = 'ArgumentNullError';
    }
}